import {Component, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {FileItem, FileUploader} from 'ng2-file-upload';
import {environment} from '../../../../environments/environment';
import {AuthenticationService} from '../../Services/authentication.service';
import {FieldType} from '@ngx-formly/core';
import {FileManager} from '../../Models/FileManager';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

const baseUri = environment.apiUrl;

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileUploaderComponent),
      multi: true
    }
  ]
})
export class FileUploaderComponent implements OnInit, ControlValueAccessor {
  @Input() label: string;
  @Input() description: string;
  @Input() accept: string;
  @Input() scope: 'backoffice' | 'dealer-system' = 'backoffice';
  @Input() bupload: string;
  @Input() fieldName: string;
  @Input() queueLimit = 1;
  @Input() ngModel: Array<any> = [];
  @Output() ngModelChange: EventEmitter<Array<FileManager> | FileManager> = new EventEmitter();
  public firstModel: Array<FileManager> = [];
  public uploadedItems: Array<FileManager> = [];
  public uploader: FileUploader = new FileUploader({url: ''});

  constructor(
    private auth: AuthenticationService
  ) {
  }

  writeValue(value: Array<FileManager>): void {
    this.ngModel = value;
    this.ngOnInit();
  }

  registerOnChange(fn: Function): void {
    this.ngModelChange.subscribe(v => {
      fn(v);
    });
  }

  registerOnTouched(fn: Function): void {
    this.ngModelChange.subscribe(v => {
      fn(v);
    });
  }

  setDisabledState?(isDisabled: boolean): void {
  }

  ngOnInit() {
    this.firstModel = [];
    this.uploadedItems = [];
    if (this.ngModel) {
      this.firstModel = ((this.ngModel instanceof Array) ? this.ngModel : [this.ngModel]);
    }
    this.uploader = new FileUploader({
      itemAlias: this.fieldName,
      url: baseUri + '/' + this.scope + '/file_manager?bupload=' + this.bupload + '&quality=75',
      authToken: this.auth.getBearerHeader(),
      queueLimit: this.queueLimit
    });
    this.uploader.onAfterAddingFile = (item => {
      if ((this.firstModel.length + this.uploader.queue.length) > this.queueLimit) {
        return item.remove();
      }
      item.withCredentials = false;
      item.upload();
    });
    this.uploader.onSuccessItem = (item, response) => {
      this.uploadedItems.push(JSON.parse(response));
      this.updateModel();
      item.remove();
    };
  }

  updateModel() {
    this.ngModelChange.emit(
      this.queueLimit > 1 ?
        [...this.firstModel, ...this.uploadedItems] :
        (this.uploadedItems[0] ? this.uploadedItems[0] : this.firstModel)
    );
  }

  stop(item: FileItem) {
    item.cancel();
  }

  remove(index: number) {
    this.firstModel.splice(index, 1);
    this.updateModel();
  }

  removeUploaded(index: number) {
    this.uploadedItems.splice(index, 1);
    this.updateModel();
  }
}
